module.exports = "/assets/data/fa9192d3ece5d09d76f4e82e58275bef-DN4.data.json";